import React from "react";
import SuperAdminDashboard from "../superadmin/dashboard/DashboardPage";

const DashboardPage = () => {
    return <SuperAdminDashboard />;
};

export default DashboardPage;
